import script from "./Index.vue?vue&type=script&lang=ts&setup=true"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true"

import "./Index.vue?vue&type=style&index=0&id=7ac4324c&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=7ac4324c&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=2&id=7ac4324c&lang=scss"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac4324c"]])

export default __exports__